import React from 'react';

import './tableRankingTitle.scss';
import { Row, Col } from 'react-flexbox-grid';

const TableRankingTitle = () => {
  const renderHeader = () => {
    return (
      <Col xs={12} className='table-ranking'>
        <Row className='table-ranking_title-container hide-desktop'>
          {/* <Col xs={2} className='table-ranking_title'>
            POS
          </Col> */}
          <Col xs={5} className='table-ranking_title name'>
            NOMBRE
          </Col>
          <Col xs={2} className='table-ranking_title stat'>
            KM’s
          </Col>
          <Col xs={2} className='table-ranking_title stat'>
            Avg Pace
          </Col>
          <Col xs={3} className='table-ranking_title stat'>
            Tiempo
          </Col>
        </Row>
        <Row className='table-ranking_title-container hide-mobile'>
          {/* <Col xs={2} className='table-ranking_title'>
            POSICIÓN
          </Col> */}
          <Col xs={6} className='table-ranking_title name'>
            NOMBRE
          </Col>
          <Col xs={2} className='table-ranking_title stat'>
            KM’s
          </Col>
          <Col xs={2} className='table-ranking_title stat'>
            Avg Pace
          </Col>
          <Col xs={2} className='table-ranking_title stat'>
            Tiempo
          </Col>
        </Row>
      </Col>
    );
  };
  return renderHeader();
};

export default TableRankingTitle;
